import { render, staticRenderFns } from "./mmStatistics.vue?vue&type=template&id=03965ee4&scoped=true"
import script from "./mmStatistics.vue?vue&type=script&lang=js"
export * from "./mmStatistics.vue?vue&type=script&lang=js"
import style0 from "./mmStatistics.vue?vue&type=style&index=0&id=03965ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03965ee4",
  null
  
)

export default component.exports